import {api} from "../plugins/axios";
import {
    IamportPaymentConfirmRequest,
    PayConfirmRequestMobileV2Dto,
    OrderStartV2Dto,
    PayConfirmResultV2Dto,
    PayStartResultV2Dto, RequestStartV2Dto
} from "../types/iamport";
import {OrderCancelRequest, TResponse} from "../types/types";

export const iamportOrderStart = (orderNumber: string, data: OrderStartV2Dto) => {
    return api.post<TResponse<PayStartResultV2Dto>>(`/v1/orders/port/payment/order/${orderNumber}`, data)
}

export const iamportPaymentConfirm = (data: IamportPaymentConfirmRequest) => {
    return api.post<TResponse<PayConfirmResultV2Dto>>(`/v1/orders/port/payment/confirm`, data)
}

export const iamportPaymentMobileConfirm = (siteName: string, data: PayConfirmRequestMobileV2Dto) => {
    return api.post<TResponse<PayConfirmResultV2Dto>>(`/v1/orders/port/payment/confirm/mobile/${siteName}`, data)
}

export const iamportPaymentCancel = (orderNumber: string, data: OrderCancelRequest) => {
    return api.post<TResponse<void>>(`/v1/orders/port/payment/cancel/${orderNumber}`, data)
}

export const iamportPaymentRequest = (orderNumber: string, data: RequestStartV2Dto) => {
    return api.post<TResponse<PayStartResultV2Dto>>(`/v1/orders/port/payment/request/${orderNumber}`, data)
}

